/* ==========================================================================
   CR2 Product Gallery — imagen principal con AUTO-DETECCIÓN de arquitectura.
   Tres "túneles" sin flag manual; el tema se adapta a la forma del dato:

   A) NUEVO con metafield custom.frame_mockups (modelo objetivo, p. ej. piloto):
      Marco = {Sin marco, Con marco}. Color = line-item property (no variante).
      Imagen: "Sin marco" → imagen nativa de variante; "Con marco" →
      frame_mockups[Formato][Color].

   B) Imagen por variante sin metafield (interino, p. ej. opulencia):
      cada variante (incluido color) trae featured_image → imagen nativa.

   C) Legacy sin imagen de variante (p. ej. colibri):
      switcher por convención de nombre de archivo.

   En todos: cambiar Formato salta a variante válida (dimensiones distintas).
   Precio/variante/carrito = Dawn (variant-radios).
   ========================================================================== */
(function () {
  function base(url) { return (url || '').split('?')[0]; }
  function fileName(url) { return base(url).split('/').pop(); }
  function withW(u, w) { return base(u) + '?width=' + w; }
  function srcsetFor(u) { return [700, 1100, 1400, 1800].map(function (w) { return withW(u, w) + ' ' + w + 'w'; }).join(', '); }
  function isConMarco(v) { return !!v && v.toLowerCase().indexOf('sin') === -1; }

  function initGallery(root) {
    var main = root.querySelector('.cr2-pgallery__main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.cr2-pgallery__thumb'));
    if (!main || !thumbs.length) return;

    var section = root.closest('[data-section]') || document;
    var productData = null, variantImgSet = null, hasVariantImages = false;

    // Metafield frame_mockups (túnel A)
    var frameMockups = null;
    var fmEl = (section.querySelector || document.querySelector).call(section, '[data-cr2-frame-mockups]') ||
               document.querySelector('[data-cr2-frame-mockups]');
    if (fmEl) { try { frameMockups = JSON.parse(fmEl.textContent.trim()); } catch (e) { frameMockups = null; } }
    var hasFrameMockups = !!frameMockups && Object.keys(frameMockups).length > 0;

    var colorField = document.querySelector('[data-cr2-framecolor]');
    var colorInputs = Array.prototype.slice.call(document.querySelectorAll('input[name="properties[Color de marco]"]'));

    function selectedValue(name) {
      var el = section.querySelector('input[name="' + name + '"]:checked, select[name="' + name + '"]');
      return el ? el.value.trim() : null;
    }
    function selectedColor() {
      var c = colorInputs.find(function (i) { return i.checked; });
      return c ? c.value.trim() : (colorInputs[0] ? colorInputs[0].value.trim() : null);
    }
    function fmLookup(formato, color) {
      if (!frameMockups) return null;
      var f = frameMockups[formato] || frameMockups[Object.keys(frameMockups).find(function (k) { return k.toLowerCase() === (formato || '').toLowerCase(); })];
      if (!f) return null;
      return f[color] || f[Object.keys(f).find(function (k) { return k.toLowerCase() === (color || '').toLowerCase(); })] || null;
    }

    function getProduct() {
      if (productData) return Promise.resolve(productData);
      return fetch(location.pathname + '.js').then(function (r) { return r.json(); }).then(function (p) {
        productData = p;
        variantImgSet = new Set(p.variants.filter(function (v) { return v.featured_image; }).map(function (v) { return fileName(v.featured_image.src); }));
        hasVariantImages = variantImgSet.size > 0;
        return p;
      });
    }
    function currentVariant() {
      if (!productData) return null;
      var f = selectedValue('Formato'), d = selectedValue('Dimensión'), m = selectedValue('Marco');
      return productData.variants.find(function (v) {
        return (f == null || v.option1 === f) && (d == null || v.option2 === d) && (m == null || v.option3 === m);
      }) || null;
    }

    function setMain(u, alt) {
      if (!u) return;
      main.src = withW(u, 1400); main.srcset = srcsetFor(u); if (alt) main.alt = alt;
    }
    function markActive(thumb) { thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); }); }

    function setMainFromVariant() {
      var v = currentVariant();
      if (v && v.featured_image) {
        setMain(base(v.featured_image.src), v.featured_image.alt || productData.title);
        var fn = fileName(v.featured_image.src);
        markActive(thumbs.find(function (t) { return fileName(t.getAttribute('data-full')) === fn; }));
        return true;
      }
      return false;
    }
    function setMainFromConvention() {
      var formato = selectedValue('Formato'), marco = selectedValue('Marco');
      if (!formato && !marco) return;
      var match = thumbs.find(function (t) {
        return t.getAttribute('data-role') !== 'support' &&
          (!formato || t.getAttribute('data-formato') === formato) && (!marco || t.getAttribute('data-marco') === marco);
      }) || thumbs.find(function (t) {
        return t.getAttribute('data-role') === 'artwork' && (!formato || t.getAttribute('data-formato') === formato);
      });
      if (match) { setMain(base(match.getAttribute('data-full')), match.getAttribute('data-alt')); markActive(match); }
    }

    function refreshMain() {
      if (hasFrameMockups) {
        var marco = selectedValue('Marco');
        if (isConMarco(marco)) {
          var img = fmLookup(selectedValue('Formato'), selectedColor());
          if (img) { setMain(img, productData ? productData.title : ''); return; }
        }
        if (setMainFromVariant()) return;   // "Sin marco" → nativa
      }
      if (hasVariantImages) { if (setMainFromVariant()) return; }
      setMainFromConvention();
    }

    // Mostrar/ocultar + habilitar el selector de color según Marco
    function syncColorSelector() {
      if (!colorField) return;
      var con = isConMarco(selectedValue('Marco'));
      colorField.hidden = !con;
      colorInputs.forEach(function (i) { i.disabled = !con; });
    }

    function goToFormato(formato) {
      var marco = selectedValue('Marco');
      getProduct().then(function (p) {
        var v = p.variants.find(function (x) { return x.option1 === formato && x.option3 === marco && x.available; }) ||
                p.variants.find(function (x) { return x.option1 === formato && x.available; }) ||
                p.variants.find(function (x) { return x.option1 === formato; });
        if (v) { var u = new URL(location.href); u.searchParams.set('variant', v.id); location.assign(u.toString()); }
      });
    }

    function commonPrefix(arr) {
      if (!arr.length) return '';
      var p = arr[0];
      for (var i = 1; i < arr.length; i++) { while (arr[i].indexOf(p) !== 0) { p = p.slice(0, -1); if (!p) return ''; } }
      return p;
    }
    function applyThumbVisibility() {
      if (!hasVariantImages) return;
      var prefix = commonPrefix(Array.from(variantImgSet));
      thumbs.forEach(function (t) {
        var fn = fileName(t.getAttribute('data-full'));
        var isMockup = variantImgSet.has(fn) || (prefix.length >= 10 && fn.indexOf(prefix) === 0);
        t.classList.toggle('cr2-pgallery__thumb--hidden', isMockup);
      });
    }

    thumbs.forEach(function (t) {
      var btn = t.querySelector('.cr2-pgallery__thumb-btn');
      if (btn) btn.addEventListener('click', function () { setMain(base(t.getAttribute('data-full')), t.getAttribute('data-alt')); markActive(t); });
    });

    section.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.name === 'Formato') { goToFormato(e.target.value.trim()); }
      else if (e.target.name === 'Marco') { syncColorSelector(); refreshMain(); }
      else if (e.target.name === 'Dimensión') { refreshMain(); }
      else if (e.target.name === 'properties[Color de marco]') { refreshMain(); }
    });
    document.addEventListener('variant:change', refreshMain);

    getProduct().then(function () {
      applyThumbVisibility();
      syncColorSelector();
      refreshMain();
    });
  }

  function boot() { document.querySelectorAll('.cr2-pgallery').forEach(initGallery); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
